module.exports = __webpack_public_path__ + "img/shiro-dango1.136dc48b.jpeg";